module.exports = __webpack_public_path__ + "img/polygon-logo.00e45740.svg";